// Small shared helper so AskOperator, AskFAB, WakeSally, and the Settings
// preview all speak with the same voice. Persisted in localStorage.
const KEY = "op:sally:voice";
const DEFAULT = "shimmer";

export const VOICES = [
  { id: "shimmer", label: "SHIMMER",  note: "soft · warm · feminine (default)" },
  { id: "nova",    label: "NOVA",     note: "bright · confident · feminine" },
  { id: "alloy",   label: "ALLOY",    note: "neutral · balanced" },
  { id: "echo",    label: "ECHO",     note: "male · calm · natural" },
  { id: "fable",   label: "FABLE",    note: "male · warm · storyteller" },
  { id: "onyx",    label: "ONYX",     note: "male · deep · authoritative" },
];

export const getVoice = () => {
  try { return localStorage.getItem(KEY) || DEFAULT; } catch { return DEFAULT; }
};

export const setVoice = (v) => {
  try { localStorage.setItem(KEY, v); } catch { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent("op:voice-changed", { detail: v })); } catch { /* ignore */ }
};
